module.exports = __webpack_public_path__ + "img/mind_template_item_2_4.d0c7b985.png";